import { TFunction } from 'i18next';
import { ChipProps, RAGPillColours } from '@components-clean/core/grid/custom-cell/chip-constants';
import {
    ControlsHubPanelObservationActions,
    ControlsHubPanelObservationReviewLogs,
    ControlsHubPanelObservations,
} from '@interfaces/central-monitoring';

export const statusRAGChips = (t: TFunction): ChipProps[] => {
    return [
        {
            text: t('shared.none'),
            value: t('shared.none'),
            backgroundColor: RAGPillColours.ragNone,
            borderColor: RAGPillColours.ragNoneBorder,
        },
        {
            text: t('shared.upperRed'),
            value: t('shared.upperRed'),
            backgroundColor: RAGPillColours.ragRed,
            borderColor: RAGPillColours.ragRedBorder,
        },
        {
            text: t('shared.upperAmber'),
            value: t('shared.upperAmber'),
            backgroundColor: RAGPillColours.ragAmber,
            borderColor: RAGPillColours.ragAmberBorder,
        },
        {
            text: t('shared.lowerAmber'),
            value: t('shared.lowerAmber'),
            backgroundColor: RAGPillColours.ragAmber,
            borderColor: RAGPillColours.ragAmberBorder,
        },
        {
            text: t('shared.lowerRed'),
            value: t('shared.lowerRed'),
            backgroundColor: RAGPillColours.ragRed,
            borderColor: RAGPillColours.ragRedBorder,
        },
        {
            text: t('shared.belowMinData'),
            value: t('shared.belowMinData'),
            backgroundColor: RAGPillColours.ragGrey,
            borderColor: RAGPillColours.ragGreyBorder,
        },
        {
            text: t('shared.green'),
            value: t('shared.green'),
            backgroundColor: RAGPillColours.ragGreen,
            borderColor: RAGPillColours.ragGreenBorder,
        },
    ];
};

export interface ConvertedControlsHubPanelObservations extends Partial<
    Omit<ControlsHubPanelObservations, 'owner' | 'association' | 'panel' | 'decision'>
> {
    owner: {
        name?: string | null;
        active?: boolean | null;
    };
    association: {
        name?: string | null;
        active?: boolean | null;
    };
    panel: {
        id?: string | null;
        name?: string | null;
        panelRef?: string | null;
        active?: boolean | null;
    };
    decision: {
        name?: string | null;
        active?: boolean | null;
    };
}

export interface ConvertedControlsHubPanelObservationReviewLogs extends Partial<
    Omit<
        ControlsHubPanelObservationReviewLogs,
        'decision' | 'panel' | 'y_value' | 'y_value_change' | 'numerator_events' | 'denominator_count'
    >
> {
    panel: {
        name?: string | null;
        active?: boolean | null;
    };
    decision: {
        id?: string | null;
        name?: string | null;
        active?: boolean | null;
    };
    y_value?: number | null;
    y_value_change?: number | null;
    numerator_events?: number | null;
    denominator_count?: number | null;
}
export interface ConvertedControlsHubPanelObservationActions extends Partial<
    Omit<ControlsHubPanelObservationActions, 'owner' | 'association' | 'panel' | 'responsible_function'>
> {
    owner: {
        name?: string | null;
        active?: boolean | null;
    };
    association: {
        name?: string | null;
        active?: boolean | null;
    };
    panel: {
        id?: string | null;
        name?: string | null;
        active?: boolean | null;
    };
    responsible_function: {
        name?: string | null;
        active?: boolean | null;
    };
}
